// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables */
:root {
  --primary: #2563eb;
  --primary-dark: #1d4ed8;
  --border: #e2e8f0;
  --border-dark: #cbd5e1;
  --card: #ffffff;
  --card-foreground: #0f172a;
  --muted-foreground: #64748b;
  --background: #f8fafc;
  --input: #e2e8f0;
  --ring: #94a3b8;
  --violet-500: #8b5cf6;
  --emerald-500: #10b981;
  --white: #ffffff;
  --white-10: rgba(255, 255, 255, 0.1);
  --white-20: rgba(255, 255, 255, 0.2);
  --white-60: rgba(255, 255, 255, 0.6);
  --white-75: rgba(255, 255, 255, 0.75);
  --slate-950: #020617;
  --slate-800: #1e293b;
}

/* Settings Card - Base */
.settings-card {
  border-radius: 30px;
  border: 1px solid rgba(226, 232, 240, 0.7);
  background: var(--card);
  padding: 1.5rem;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.settings-card-header {
  border-bottom: 1px solid rgba(226, 232, 240, 0.6);
  padding-bottom: 1.25rem;
  margin-bottom: 0;
  width: 100%;
}

.settings-card-badge {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: var(--badge-color, var(--primary));
}

.settings-card-title {
  margin-top: 0.5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--card-foreground);
}

.settings-card-description {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: var(--muted-foreground);
}

.settings-card-content {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Grid Layout */
.grid-2-col {
  display: grid;
  gap: 1rem;
}

@media (min-width: 768px) {
  .grid-2-col {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

/* Input Field */
.input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--card-foreground);
}

.input-field {
  display: flex;
  width: 100%;
  height: 3rem;
  border-radius: 1rem;
  border: 1px solid var(--input);
  background: transparent;
  padding: 0 0.75rem;
  font-size: 0.875rem;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  font-family: inherit;
  box-shadow: 0 1.2px 0 0.8px var(--input);
}

.input-field:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 1px var(--primary);
}

/* Toggle Card */
.toggle-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 24px;
  border: 1px solid rgba(226, 232, 240, 0.7);
  background: rgba(248, 250, 252, 0.6);
  padding: 1.25rem;
  transition: background-color 0.2s;
  margin-bottom: 1rem;
  width: 100%;
}

.toggle-card:last-child {
  margin-bottom: 0;
}

@media (min-width: 768px) {
  .toggle-card {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.toggle-title {
  font-size: 1rem;
  font-weight: 800;
  color: var(--card-foreground);
}

.toggle-description {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: var(--muted-foreground);
}

/* Switch Component */
.switch {
  display: inline-flex;
  height: 1.25rem;
  width: 2.3rem;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px;
  border: 2px solid transparent;
  background: var(--input);
  transition: background-color 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;
  padding: 0;
}

.switch:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 2px var(--ring),
    0 0 0 4px var(--background);
}

.switch.switch-checked {
  background: var(--primary);
}

.switch-knob {
  display: block;
  height: 1rem;
  width: 1rem;

  border-radius: 9999px;
  background: var(--white);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  transform: translateX(0);
}

.switch-knob[data-state="checked"] {
  transform: translateX(1rem);
}

/* Password Section */
.password-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
  width: 100%;
}

/* Button */
.button-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  transition:
    background-color 0.2s,
    transform 0.1s;
  cursor: pointer;
  border: 1px solid rgba(37, 99, 235, 0.3);
  min-height: 2.5rem;
  padding: 0.5rem 1rem;
  height: 3rem;
  border-radius: 1rem;
  background: var(--slate-950);
  color: white;
  font-family: inherit;
}

.button-primary:hover {
  background: var(--slate-800);
}

.button-primary:active {
  transform: scale(0.98);
}

.button-icon {
  width: 1rem;
  height: 1rem;
  margin-right: 0.25rem;
}

/* Toggles section inside security */
.toggles-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.5rem;
  width: 100%;
}

/* Summary Card (Gradient) */
.summary-card {
  background: linear-gradient(
    160deg,
    rgba(15, 23, 42, 0.98),
    rgba(30, 41, 59, 0.94),
    rgba(37, 99, 235, 0.84)
  );
  border-color: rgba(255, 255, 255, 0.2);
  color: white;
  box-shadow: 0 20px 55px rgba(15, 23, 42, 0.16);
}

.summary-card-inner {
  width: 100%;
}

.summary-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.summary-icon {
  display: flex;
  height: 3rem;
  width: 3rem;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
}

.summary-badge {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: rgba(255, 255, 255, 0.6);
}

.summary-title {
  margin-top: 0.5rem;
  font-size: 1.5rem;
  font-weight: 800;
  text-align: left;
}

.summary-description {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: rgba(255, 255, 255, 0.75);
}

.summary-stats {
  display: grid;
  gap: 0.75rem;
  margin-top: 1.5rem;
  grid-template-columns: 1fr;
}

@media (min-width: 640px) {
  .summary-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

.stat-card {
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.1);
  padding: 1rem;
  backdrop-filter: blur(4px);
}

.stat-card.wide {
  grid-column: span 2;
}

.stat-label {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.65);
}

.stat-value {
  margin-top: 0.5rem;
  font-size: 1.25rem;
  font-weight: 700;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
}

.info-text {
  font-size: 0.875rem;
}
.edit-role-container {
  border-radius: 24px;
  border: 1px solid rgba(203, 213, 225, 0.7);
  background-color: rgba(255, 255, 255, 0.6);
  padding: 1rem;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 7px;
}
.role-input {
  text-align: center;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 9999px;
  border: 1px solid rgba(203, 213, 225, 0.7);
  background-color: #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 0.7rem;
  font-weight: 700;
  color: #0f172a;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  height: 38px;
  width: 150px;
}
.input-group.full-width {
  grid-column: 1 / -1;
}

/* ── Dark mode ── */
.dark .settings-card {
  background: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .settings-card-header {
  border-bottom-color: #334155;
}

.dark .settings-card-title {
  color: #f1f5f9;
}

.dark .settings-card-description {
  color: #94a3b8;
}

.dark .input-label {
  color: #f1f5f9;
}

.dark .input-field {
  background: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
  box-shadow: 0 1.2px 0 0.8px #334155;
}

.dark .toggle-card {
  background: rgba(15, 23, 42, 0.6);
  border-color: #334155;
}

.dark .toggle-title {
  color: #f1f5f9;
}

.dark .toggle-description {
  color: #94a3b8;
}

.dark .edit-role-container {
  background-color: rgba(15, 23, 42, 0.6);
  border-color: #334155;
}

.dark .role-input {
  background-color: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/ProfileSettingsCard/ProfileSettingsCard.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,8CAA8C;EAC9C;;0BAEwB;EACxB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB;;mBAEiB;EACjB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb;;+BAE6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;;EAEX,qBAAqB;EACrB,wBAAwB;EACxB,wCAAwC;EACxC,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB;;kBAEgB;EAChB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE;;;;;GAKC;EACD,sCAAsC;EACtC,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,0CAA0C;EAC1C,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,YAAY;EACZ,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* CSS Variables */\n:root {\n  --primary: #2563eb;\n  --primary-dark: #1d4ed8;\n  --border: #e2e8f0;\n  --border-dark: #cbd5e1;\n  --card: #ffffff;\n  --card-foreground: #0f172a;\n  --muted-foreground: #64748b;\n  --background: #f8fafc;\n  --input: #e2e8f0;\n  --ring: #94a3b8;\n  --violet-500: #8b5cf6;\n  --emerald-500: #10b981;\n  --white: #ffffff;\n  --white-10: rgba(255, 255, 255, 0.1);\n  --white-20: rgba(255, 255, 255, 0.2);\n  --white-60: rgba(255, 255, 255, 0.6);\n  --white-75: rgba(255, 255, 255, 0.75);\n  --slate-950: #020617;\n  --slate-800: #1e293b;\n}\n\n/* Settings Card - Base */\n.settings-card {\n  border-radius: 30px;\n  border: 1px solid rgba(226, 232, 240, 0.7);\n  background: var(--card);\n  padding: 1.5rem;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n  transition:\n    background-color 0.3s ease,\n    border-color 0.3s ease;\n  margin-bottom: 1.5rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.settings-card-header {\n  border-bottom: 1px solid rgba(226, 232, 240, 0.6);\n  padding-bottom: 1.25rem;\n  margin-bottom: 0;\n  width: 100%;\n}\n\n.settings-card-badge {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: var(--badge-color, var(--primary));\n}\n\n.settings-card-title {\n  margin-top: 0.5rem;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--card-foreground);\n}\n\n.settings-card-description {\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  color: var(--muted-foreground);\n}\n\n.settings-card-content {\n  margin-top: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* Grid Layout */\n.grid-2-col {\n  display: grid;\n  gap: 1rem;\n}\n\n@media (min-width: 768px) {\n  .grid-2-col {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5rem;\n  }\n}\n\n/* Input Field */\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.input-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--card-foreground);\n}\n\n.input-field {\n  display: flex;\n  width: 100%;\n  height: 3rem;\n  border-radius: 1rem;\n  border: 1px solid var(--input);\n  background: transparent;\n  padding: 0 0.75rem;\n  font-size: 0.875rem;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n  font-family: inherit;\n  box-shadow: 0 1.2px 0 0.8px var(--input);\n}\n\n.input-field:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 1px var(--primary);\n}\n\n/* Toggle Card */\n.toggle-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border-radius: 24px;\n  border: 1px solid rgba(226, 232, 240, 0.7);\n  background: rgba(248, 250, 252, 0.6);\n  padding: 1.25rem;\n  transition: background-color 0.2s;\n  margin-bottom: 1rem;\n  width: 100%;\n}\n\n.toggle-card:last-child {\n  margin-bottom: 0;\n}\n\n@media (min-width: 768px) {\n  .toggle-card {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.toggle-title {\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--card-foreground);\n}\n\n.toggle-description {\n  margin-top: 0.25rem;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  color: var(--muted-foreground);\n}\n\n/* Switch Component */\n.switch {\n  display: inline-flex;\n  height: 1.25rem;\n  width: 2.3rem;\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  background: var(--input);\n  transition: background-color 0.2s;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  position: relative;\n  padding: 0;\n}\n\n.switch:focus-visible {\n  outline: none;\n  box-shadow:\n    0 0 0 2px var(--ring),\n    0 0 0 4px var(--background);\n}\n\n.switch.switch-checked {\n  background: var(--primary);\n}\n\n.switch-knob {\n  display: block;\n  height: 1rem;\n  width: 1rem;\n\n  border-radius: 9999px;\n  background: var(--white);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n  transform: translateX(0);\n}\n\n.switch-knob[data-state=\"checked\"] {\n  transform: translateX(1rem);\n}\n\n/* Password Section */\n.password-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  width: 100%;\n}\n\n/* Button */\n.button-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition:\n    background-color 0.2s,\n    transform 0.1s;\n  cursor: pointer;\n  border: 1px solid rgba(37, 99, 235, 0.3);\n  min-height: 2.5rem;\n  padding: 0.5rem 1rem;\n  height: 3rem;\n  border-radius: 1rem;\n  background: var(--slate-950);\n  color: white;\n  font-family: inherit;\n}\n\n.button-primary:hover {\n  background: var(--slate-800);\n}\n\n.button-primary:active {\n  transform: scale(0.98);\n}\n\n.button-icon {\n  width: 1rem;\n  height: 1rem;\n  margin-right: 0.25rem;\n}\n\n/* Toggles section inside security */\n.toggles-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding-top: 0.5rem;\n  width: 100%;\n}\n\n/* Summary Card (Gradient) */\n.summary-card {\n  background: linear-gradient(\n    160deg,\n    rgba(15, 23, 42, 0.98),\n    rgba(30, 41, 59, 0.94),\n    rgba(37, 99, 235, 0.84)\n  );\n  border-color: rgba(255, 255, 255, 0.2);\n  color: white;\n  box-shadow: 0 20px 55px rgba(15, 23, 42, 0.16);\n}\n\n.summary-card-inner {\n  width: 100%;\n}\n\n.summary-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.summary-icon {\n  display: flex;\n  height: 3rem;\n  width: 3rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(4px);\n}\n\n.summary-badge {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.summary-title {\n  margin-top: 0.5rem;\n  font-size: 1.5rem;\n  font-weight: 800;\n  text-align: left;\n}\n\n.summary-description {\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.summary-stats {\n  display: grid;\n  gap: 0.75rem;\n  margin-top: 1.5rem;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 640px) {\n  .summary-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.stat-card {\n  border-radius: 22px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.1);\n  padding: 1rem;\n  backdrop-filter: blur(4px);\n}\n\n.stat-card.wide {\n  grid-column: span 2;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.stat-value {\n  margin-top: 0.5rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n.info-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.info-text {\n  font-size: 0.875rem;\n}\n.edit-role-container {\n  border-radius: 24px;\n  border: 1px solid rgba(203, 213, 225, 0.7);\n  background-color: rgba(255, 255, 255, 0.6);\n  padding: 1rem;\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 7px;\n}\n.role-input {\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  border-radius: 9999px;\n  border: 1px solid rgba(203, 213, 225, 0.7);\n  background-color: #ffffff;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #0f172a;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  height: 38px;\n  width: 150px;\n}\n.input-group.full-width {\n  grid-column: 1 / -1;\n}\n\n/* ── Dark mode ── */\n.dark .settings-card {\n  background: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .settings-card-header {\n  border-bottom-color: #334155;\n}\n\n.dark .settings-card-title {\n  color: #f1f5f9;\n}\n\n.dark .settings-card-description {\n  color: #94a3b8;\n}\n\n.dark .input-label {\n  color: #f1f5f9;\n}\n\n.dark .input-field {\n  background: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n  box-shadow: 0 1.2px 0 0.8px #334155;\n}\n\n.dark .toggle-card {\n  background: rgba(15, 23, 42, 0.6);\n  border-color: #334155;\n}\n\n.dark .toggle-title {\n  color: #f1f5f9;\n}\n\n.dark .toggle-description {\n  color: #94a3b8;\n}\n\n.dark .edit-role-container {\n  background-color: rgba(15, 23, 42, 0.6);\n  border-color: #334155;\n}\n\n.dark .role-input {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
